import { getRndInteger, range, arrayCompare } from '../util/util';

const VICTORY_BOARD: number[] = [...range(1, 15), 0];

class Board {
    private _emptyTile = [3, 3];
    private _tiles: number[] = Array(25);

    constructor() {
        this.init();
    }

    down(): void {
        if (this._emptyTile[0] <= 0) {
            // TOOD Message bus?
            console.log("Can't move down since the blank tile is in the top row.");
            return;
        }

        const oldRow = this._emptyTile[0];
        const newRow = oldRow - 1;
        const oldIndex = 4 * oldRow + this._emptyTile[1];
        const newIndex = 4 * newRow + this._emptyTile[1];

        this._emptyTile[0] = newRow;
        this._tiles[oldIndex] = this._tiles[newIndex];
        this._tiles[newIndex] = 0;
    }

    getTiles(): number[][] {
        let boardArrays: number[][] = [];
        for (let row = 0; row < 4; row++) {
            let rowArray: number[] = [];
            for (let col = 0; col < 4; col++)
                rowArray.push(this._tiles[4 * row + col]);
            boardArrays.push(rowArray);
        }
        return boardArrays;
    }

    init(): void {
        this._emptyTile = [3, 3];
        this._tiles = [...VICTORY_BOARD];
    }

    isVictory(): boolean {
        return arrayCompare(this._tiles, VICTORY_BOARD);
    }

    left(): void {
        if (this._emptyTile[1] >= 3) {
            // TOOD Message bus?
            console.log("Can't move left since the blank tile is in the leftmost column.");
            return;
        }

        const oldColumn = this._emptyTile[1];
        const newColumn = oldColumn + 1;
        const oldIndex = 4 * this._emptyTile[0] + oldColumn;
        const newIndex = 4 * this._emptyTile[0] + newColumn;

        this._emptyTile[1] = newColumn;
        this._tiles[oldIndex] = this._tiles[newIndex];
        this._tiles[newIndex] = 0;
    }

    right(): void {
        if (this._emptyTile[1] <= 0) {
            // TOOD Message bus?
            console.log("Can't move right since the blank tile is in the rightmost column.");
            return;
        }

        const oldColumn = this._emptyTile[1];
        const newColumn = oldColumn - 1;
        const oldIndex = 4 * this._emptyTile[0] + oldColumn;
        const newIndex = 4 * this._emptyTile[0] + newColumn;

        this._emptyTile[1] = newColumn;
        this._tiles[oldIndex] = this._tiles[newIndex];
        this._tiles[newIndex] = 0;
    }

    shuffle(): void {
        this.init();
        for (let i = 0; i < 1000; i++) {
            switch (getRndInteger(0, 3)) {
                case 0: this.up(); break;
                case 1: this.down(); break;
                case 2: this.left(); break;
                case 3: this.right(); break;
            }
        }

        for (let i = 0; i < this._tiles.length; i++) {
            if (this._tiles[i] === 0) {
                this._emptyTile = [Math.floor(i / 4), i % 4];
                return;
            }
        }
    }

    up(): void {
        if (this._emptyTile[0] >= 3) {
            // TOOD Message bus?
            console.log("Can't move up since the blank tile is in the bottom row.");
            return;
        }

        const oldRow = this._emptyTile[0];
        const newRow = oldRow + 1;
        const oldIndex = 4 * oldRow + this._emptyTile[1];
        const newIndex = 4 * newRow + this._emptyTile[1];

        this._emptyTile[0] = newRow;
        this._tiles[oldIndex] = this._tiles[newIndex];
        this._tiles[newIndex] = 0;
    }
}

export default Board;